import type { ReceiptTemplate } from '../schema';

export const turoTemplate: ReceiptTemplate = {
  id: 'turo',
  name: 'Turo Receipt',
  brand: 'TURO',
  description: 'Turo car rental receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'turo-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'TURO',
        businessNameFontSize: 22,
        addressLines: ['TRIP RECEIPT'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'turo-trip',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trip', label: 'Trip #:', value: 'TURO-847291' },
          { id: 'guest', label: 'Guest:', value: 'John Doe' },
        ],
        column2: [
          { id: 'start', label: 'Start:', value: '01/02/2026' },
          { id: 'end', label: 'End:', value: '01/05/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'turo-vehicle',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'left', message: 'VEHICLE:\n2023 Tesla Model 3\nHost: Mike W.', fontSize: 12, showDivider: true, dividerStyle: 'dashed', isBold: false },
    },
    {
      id: 'turo-charges',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'daily', label: 'TRIP PRICE (3 DAYS)', value: '285.00', isBold: false, isLarge: false },
          { id: 'protection', label: 'PROTECTION PLAN', value: '75.00', isBold: false, isLarge: false },
          { id: 'fee', label: 'YOUNG DRIVER FEE', value: '30.00', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '390.00', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'turo-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'turo-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'FIND YOUR DRIVE\n\nTHANK YOU', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

